import { render, staticRenderFns } from "./PlanejamentoContratoListDadosAgrupamento.vue?vue&type=template&id=052a04a2"
import script from "./PlanejamentoContratoListDadosAgrupamento.vue?vue&type=script&lang=js"
export * from "./PlanejamentoContratoListDadosAgrupamento.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoContratoListDadosAgrupamento.vue?vue&type=style&index=0&id=052a04a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports